export const NewsCenterRoutes = [{
  path: '/NewsCenter',
  component: () => import('./NewsCenter.vue'),
  meta: {
    crumbName: '新闻中心'
  },
  children: [
    {
      path: 'newsList',
      name: '新闻列表',
      component: () => import('../newsList.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:false
      }
    }, {
      path: 'newsDetails',
      name: '新闻详情',
      component: () => import('../newsDetails.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:false
      }
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/pages/NewsCenter/router/NewsCenter.routes.js